import { render } from "./MenuContent.vue?vue&type=template&id=dc7bb056"
import script from "./MenuContent.vue?vue&type=script&lang=js"
export * from "./MenuContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__